// Helpers for code paths that must build HTML strings (Leaflet popups/divIcons,
// pop-out windows written with document.write). Every interpolated value from
// the API or a third-party feed must pass through one of these.

const HTML_ESCAPES: Record<string, string> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
};

export function escapeHtml(value: unknown): string {
  if (value === null || value === undefined) return '';
  return String(value).replace(/[&<>"']/g, (ch) => HTML_ESCAPES[ch]);
}

const HEX_COLOR = /^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{4}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/;

export function safeColor(value: unknown, fallback = '#2196f3'): string {
  return typeof value === 'string' && HEX_COLOR.test(value) ? value : fallback;
}

// Allows absolute http(s) URLs and same-origin relative paths; anything else
// (javascript:, data:, protocol-relative) yields ''.
export function safeUrl(value: unknown): string {
  if (typeof value !== 'string') return '';
  const v = value.trim();
  if (/^https?:\/\//i.test(v)) return v;
  if (v.startsWith('/') && !v.startsWith('//')) return v;
  return '';
}

// JSON literal that is safe to embed inside an inline <script> block.
export function jsonForScript(value: unknown): string {
  return JSON.stringify(value ?? null)
    .replace(/</g, '\\u003c')
    .replace(/>/g, '\\u003e')
    .replace(/&/g, '\\u0026')
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029');
}
